var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinetoprightbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1914,
    height: 578,
    viewBox: "0 0 1914 578",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 319.742H11.249V159.169H0V319.742Z",
    fill: "#01FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5684 291.106H36.8404V278.835H24.5684V291.106Z",
    fill: "#01FFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5684 316.673H36.8404V304.397H24.5684V316.673Z",
    fill: "#01FFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5684 342.249H36.8404V329.974H24.5684V342.249Z",
    fill: "#01FFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5684 367.812H36.8404V355.537H24.5684V367.812Z",
    fill: "#01FFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.73242 416.062L26.2824 445.723V499.811H33.0184V443.311L8.46742 413.652V339.181H1.73242V416.062Z",
    fill: "#115C5F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.813 31.3539H398.884V24.1799H193.813V31.3539Z",
    fill: "#125D60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.719 15.671L315.249 20.413V20.404L343.275 5.394H556.059V0H341.97L312.719 15.671Z",
    fill: "#125D60"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.65 18.56H429.566V11.387H354.65V18.56Z",
    fill: "#01FFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.102 25.5239H464.946V8.59692H460.102V25.5239Z",
    fill: "#125D60"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.789 25.5239H474.623V8.59692H469.789V25.5239Z",
    fill: "#125D60"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.447 25.5239H455.28V8.59692H450.447V25.5239Z",
    fill: "#125D60"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2539 395.11H40.6599V392.41H20.2539V395.11Z",
    fill: "#01FFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2539 402.593H40.6599V399.893H20.2539V402.593Z",
    fill: "#01FFFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2539 410.075H40.6599V407.375H20.2539V410.075Z",
    fill: "#01FFFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2539 387.629H40.6599V384.929H20.2539V387.629Z",
    fill: "#01FFFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8506 520.912H19.2276V457.011H15.8506V520.912Z",
    fill: "#01FFFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.04 255.429H43.634V247.14H37.855V144.863H43.634V113.668L121.866 35.429H177.693V17.019H281.273V5.76904H150.873V11.834H112.103L20.04 103.893V255.429Z",
    fill: "#115C5F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1901.77 319.742H1913.03V159.169H1901.77V319.742Z",
    fill: "#125D60"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1876.18 291.106H1888.45V278.835H1876.18V291.106Z",
    fill: "#02FFFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1876.18 316.673H1888.45V304.397H1876.18V316.673Z",
    fill: "#02FFFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1876.18 342.238H1888.45V329.963H1876.18V342.238Z",
    fill: "#02FFFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1876.18 367.812H1888.45V355.537H1876.18V367.812Z",
    fill: "#02FFFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1879.97 577.053H1886.71V445.723L1911.26 416.062V339.181H1904.52V413.652L1879.97 443.311V577.053Z",
    fill: "#125D60"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1514.12 31.3539H1719.19V24.1799H1514.12V31.3539Z",
    fill: "#125D60"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1195.63 5.394H1569.73L1597.76 20.404L1597.77 20.414L1600.3 15.672L1571.05 0H1195.63V5.394Z",
    fill: "#125D60"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1483.45 18.56H1558.37V11.387H1483.45V18.56Z",
    fill: "#02FFFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1438.39 25.5239H1443.22V8.59692H1438.39V25.5239Z",
    fill: "#02FFFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1872.35 395.11H1892.76V392.41H1872.35V395.11Z",
    fill: "#02FFFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1872.35 402.593H1892.76V399.893H1872.35V402.593Z",
    fill: "#02FFFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1872.35 410.065H1892.76V407.365H1872.35V410.065Z",
    fill: "#02FFFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1872.35 387.629H1892.76V384.929H1872.35V387.629Z",
    fill: "#02FFFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1893.79 534.552H1897.15V457.011H1893.79V534.552Z",
    fill: "#01FFFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1631.72 17.0151H1735.31V35.4151H1791.13L1869.38 113.653V144.846H1875.16V247.117H1869.38V255.417H1892.98V103.892L1800.91 11.8351H1762.14L1762.12 11.8261V5.75708H1631.72V17.0151Z",
    fill: "#125D60"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1448.05 25.5239H1452.88V8.59692H1448.05V25.5239Z",
    fill: "#02FFFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1457.73 25.5239H1462.56V8.59692H1457.73V25.5239Z",
    fill: "#02FFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinetoprightbox);
export default __webpack_public_path__ + "static/media/linetoprightbox.5f3a7dc5d56d3c02901ee2c18409630f.svg";
export { ForwardRef as ReactComponent };